var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "referral-container" }, [
      _c("div", { staticClass: "header-section" }, [
        _c("div", { staticClass: "title-wrapper" }, [
          _c("div", { staticClass: "main-title" }, [
            _vm._v("智慧数据中心管理平台")
          ]),
          _c("div", { staticClass: "subtitle" }, [
            _vm._v("打造智能化、高效率的数据中心运维解决方案")
          ])
        ])
      ]),
      _c("div", { staticClass: "section system-overview" }, [
        _c("div", { staticClass: "section-title" }, [
          _c("span", { staticClass: "icon" }, [_vm._v("📊")]),
          _c("h2", [_vm._v("系统概述")])
        ]),
        _c("div", { staticClass: "content-card" }, [
          _c("p", [
            _vm._v(
              "本平台是一套先进的数据中心管理系统，致力于提供全方位的数据中心运维管理解决方案。通过整合多园区资源、智能化运维工具和高效的工单管理，实现数据中心的智能化运营。"
            )
          ])
        ])
      ]),
      _c("div", { staticClass: "section core-features" }, [
        _c("div", { staticClass: "section-title" }, [
          _c("span", { staticClass: "icon" }, [_vm._v("🎯")]),
          _c("h2", [_vm._v("核心功能")])
        ]),
        _c("div", { staticClass: "features-grid" }, [
          _c("div", { staticClass: "feature-card" }, [
            _c("div", { staticClass: "feature-icon" }, [_vm._v("🏢")]),
            _c("h3", [_vm._v("多园区管理")]),
            _c("p", [
              _vm._v("覆盖上海、杭州、清远等多个园区，实现统一管理和资源调配")
            ])
          ]),
          _c("div", { staticClass: "feature-card" }, [
            _c("div", { staticClass: "feature-icon" }, [_vm._v("🔧")]),
            _c("h3", [_vm._v("智能运维")]),
            _c("p", [
              _vm._v("提供服务器部署、网络配置、故障诊断等全方位运维支持")
            ])
          ]),
          _c("div", { staticClass: "feature-card" }, [
            _c("div", { staticClass: "feature-icon" }, [_vm._v("📝")]),
            _c("h3", [_vm._v("工单系统")]),
            _c("p", [_vm._v("高效的工单管理流程，快速响应各类运维需求")])
          ]),
          _c("div", { staticClass: "feature-card" }, [
            _c("div", { staticClass: "feature-icon" }, [_vm._v("📈")]),
            _c("h3", [_vm._v("资源监控")]),
            _c("p", [
              _vm._v("实时监控服务器、网络等资源状态，提供可视化数据分析")
            ])
          ])
        ])
      ]),
      _c("div", { staticClass: "section tech-advantages" }, [
        _c("div", { staticClass: "section-title" }, [
          _c("span", { staticClass: "icon" }, [_vm._v("💡")]),
          _c("h2", [_vm._v("技术优势")])
        ]),
        _c("div", { staticClass: "advantages-list" }, [
          _c("div", { staticClass: "advantage-item" }, [
            _c("div", { staticClass: "advantage-number" }, [_vm._v("01")]),
            _c("div", { staticClass: "advantage-content" }, [
              _c("h3", [_vm._v("智能化管理")]),
              _c("p", [
                _vm._v("采用先进的AI算法，实现智能化资源调度和故障预测")
              ])
            ])
          ]),
          _c("div", { staticClass: "advantage-item" }, [
            _c("div", { staticClass: "advantage-number" }, [_vm._v("02")]),
            _c("div", { staticClass: "advantage-content" }, [
              _c("h3", [_vm._v("高效协同")]),
              _c("p", [_vm._v("多角色协作机制，提升团队运维效率")])
            ])
          ]),
          _c("div", { staticClass: "advantage-item" }, [
            _c("div", { staticClass: "advantage-number" }, [_vm._v("03")]),
            _c("div", { staticClass: "advantage-content" }, [
              _c("h3", [_vm._v("安全可靠")]),
              _c("p", [_vm._v("多重安全防护机制，确保数据中心安全运行")])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }